import { Suspense } from "react"
import { createRoot } from "react-dom/client"
import { useSSR } from "react-i18next"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import "./frontend/i18n"
import storeClient from "./storeClient"

const BaseApp = () => {
  useSSR(window.initialI18nStore, window.initialLanguage)

  return (
    <Suspense fallback={<div />}>
      <Provider store={storeClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </Suspense>
  )
}

const container = document.getElementById("root")
const root = createRoot(container)
root.render(<BaseApp />)

if (module.hot) {
  module.hot.accept()
}
